/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMilestoneRequest
 */
export interface CreateMilestoneRequest {
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof CreateMilestoneRequest
     */
    target: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMilestoneRequest
     */
    rewardConfigId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMilestoneRequest
     */
    name: string;
}

/**
 * Check if a given object implements the CreateMilestoneRequest interface.
 */
export function instanceOfCreateMilestoneRequest(value: object): value is CreateMilestoneRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('rewardConfigId' in value) || value['rewardConfigId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateMilestoneRequestFromJSON(json: any): CreateMilestoneRequest {
    return CreateMilestoneRequestFromJSONTyped(json, false);
}

export function CreateMilestoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMilestoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'rewardConfigId': json['rewardConfigId'],
        'name': json['name'],
    };
}

export function CreateMilestoneRequestToJSON(json: any): CreateMilestoneRequest {
    return CreateMilestoneRequestToJSONTyped(json, false);
}

export function CreateMilestoneRequestToJSONTyped(value?: CreateMilestoneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'rewardConfigId': value['rewardConfigId'],
        'name': value['name'],
    };
}

